module.exports = __webpack_public_path__ + "static/media/library.4b0a0483.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/library.mp4
// module id = 239
// module chunks = 0